import { useEffect, useState } from "react";
import "./Header.css";

function formatClock(d: Date): string {
  const pad = (n: number) => n.toString().padStart(2, "0");
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

function formatDate(d: Date): string {
  return d
    .toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "2-digit",
      year: "2-digit",
    })
    .replace(/,/g, "");
}

export function Header() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <header className="tt-header" id="topTeletextHeader">
      <span className="tt-header__code" aria-label="Page 100">
        100
      </span>
      <span className="tt-header__title crt-glow">SUPER SMASH TV</span>
      <span className="tt-header__meta">
        <span className="tt-header__date">{formatDate(now)}</span>
        <span className="tt-header__clock" aria-live="off">
          {formatClock(now)}
        </span>
      </span>
    </header>
  );
}
